<div
  class="home-questionnaire-box home-fill_back d-flex justify-content-between mb-3"
>
  <div class="ps-4 my-auto">
    <div class="home-q-title pb-1">{{ "Home.Title" | translate }}</div>
    <div class="home-q-subtitle">
      {{ "Home.Subtitle" | translate }}
    </div>
  </div>
  @if (questionnaire && expiry.date && expiry.display) {
    <div class="my-auto me-2">
      <span class="home-dt-msg d-flex flex-column align-items-end py-auto">
        <span [ngClass]="formExpired.otherClass">
          <i [ngClass]="formExpired.iconClass"></i>
          {{ formExpired.key | translate }}</span
        >
        <span class="home-dt-val text-medium">
          {{ expiry.date | date: expiry.display }}
        </span>
      </span>
    </div>
  }
</div>
